import { Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import SignUp from "./pages/PersonalSignUp/PersonalSignUpPage";
import TypeOfAccount from "./pages/TypeOfAccount/TypeOfAccountPage";
import Otp from "./pages/Otp/OtpPage";
import BusinessSignUp from "./pages/BusinessSignUp/BusinessSignUpPage";
import Successful from "./components/SuccessfulCreationOfPaymentLink/index";
import SuccessfulCharity from "./components/SuccessfulCreationOfPaymentLink/successcharity";
import SuccessfulAdhoc from "./components/SuccessfulCreationOfPaymentLink/successAdhoc";
import Login from "./pages/Login";
import BusinessPage from "./pages/Business/BusinessPage";
import LandingPage from "./pages/Landing/LandingPages";
import Dashboard from "./pages/Dashboard/Dashboard";
import PreviewOfPayment from "./components/PreviewOfPayment/PreviewOfPayment.component";
import DashboardLayout from "./components/DashBoardComponents/DashboardLayout";
import HomeProduct from "./components/DashBoardComponents/Home/HomeProduct";
import PricingPage from "./pages/Pricing/index";
import SupportPage from "./pages/Support/index";
import Home from "./pages/Home/index";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Invoice from "./pages/Invoice";
import HomeUnverified from "./pages/HomeNotVerified";
import Transaction from "./pages/Transaction/index";
import CreatePaymentLink from "./pages/CreatePaymentLink";
import CharityPreviewOfPayment from "./pages/CharityDonation/CharityPreview";
import AuthWrapper from "./components/AuthenticationWrapper/AuthenticationWrapper";
import AddUser from "./pages/AddUserPage/AddUser";
import UserManagementHeader from "./pages/UserManagement/UserManagementHeader";
import UserProfile from "./pages/UserManagement/UserManagementBody/UserProfile";
import Permission from "./pages/UserManagement/UserManagementBody/Permission";
import AccountSettings from "./pages/UserManagement/UserManagementBody/AccountSettings";
import TransactionById from "./components/DashBoardComponents/Transaction/TransactionById";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccountBankingService from "./pages/AccountBankingService";
import AccountTransfer from "./pages/AccountTransferPage";
import EmptyPage from "./pages/EmptyPage";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsCondition from "./pages/TermsAndCondition/TermsCondition";
import AboutUs from "./pages/AboutUs/AboutUs";
import Security from "./pages/Security/Security";
import ContactUs from "./pages/ContactUs/ContactUs";
import Checkout from "./pages/CheckoutPage";
import CheckoutStatus from "./pages/CheckoutPage/CheckoutStatus";
import PaymentLinkTable from "./pages/PaymentLinkTable";
import ProductList from "./pages/Product";
import ForgotPasswordPage from "./pages/ForgotPasswordPages/ForgotPassword";
import ResetPasswordPage from "./pages/ForgotPasswordPages/ResetPassword";
import ResetPasswordOrgUserPage from "./pages/ForgotPasswordPages/ResetPasswordOrgUser";
import CompleteAccountSetupPage from "./pages/CompleteAccountSetUp";
import { returnStepperData } from "./utils/returnStepperData";
import { stepperData } from "./components/CompleteAccount/data";
import Forms from "./components/CompleteAccount/Forms";
import { useSelector } from "react-redux";
import { RootState } from "./store/rootReducer";
import BankAccountConnectionPage from "./pages/SDK/BankAccountConnection";
import IframeCommunicator from "./pages/Iframe/PostMessage";
import { PaymentCallback } from "./pages/PaymentCallback";
import { ROUTES } from "./components/DashBoardComponents/Sidebar/Routes";
import Tokenization from "./pages/Transaction/tokenization";
import { DocumentationApp } from "./pages/Documentation";

function App() {
  const { onBoardingData } = useSelector(
    (state: RootState) => state.OnBoarding
  );

  const subPaths = returnStepperData(onBoardingData)
    ?.map((item) => item?.subSteps)
    ?.flat();
  const allFormFields = subPaths?.map((subPath) => subPath?.formFields)?.flat();

  const dynamicRoutes = subPaths?.map((path) => ({
    path: path.path,
    element: (
      <Forms
        key={path.path}
        label={path.label}
        subTitle={path.subTitle}
        formFields={path.label === "Summary" ? allFormFields : path.formFields}
        hasOneCol={path.hasOneCol}
      />
    ),
  }));

  return (
    <div className="App">
      <Routes>
        <Route
          path={"/auth"}
          children={[
            <Route path="login" element={<Login />} />,
            <Route path="type-of-account" element={<TypeOfAccount />} />,
            <Route
              path={"signup"}
              children={[
                <Route path="" element={<TypeOfAccount />} />,
                <Route path="personal" element={<SignUp />} />,
                <Route path="business" element={<BusinessSignUp />} />,
              ]}
            />,
          ]}
        />
        <Route path="/" element={<LandingPage />} />
        <Route path="/callback/iframe" element={<IframeCommunicator />} />
        <Route path="/callback/" element={<PaymentCallback />} />
        <Route path="/Otp" element={<Otp />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/home-product" element={<HomeProduct />} />
        <Route path="/" element={<AboutUs />} />
        <Route path="/security" element={<Security />} />
        <Route path="/p/:id" element={<Checkout />} />
        <Route path="/p/:id/status" element={<CheckoutStatus />} />
        <Route
          path="/dashboard"
          element={
            <AuthWrapper>
              <DashboardLayout>
                <Outlet />
              </DashboardLayout>
            </AuthWrapper>
          }
          children={[
            <Route path="" element={<Home />} />,
            <Route path="home" element={<Home />} />,
            <Route path="payment" element={<Dashboard />} />,
            <Route path="" element={<Dashboard />} />,
            // <Route path="success" element={<Successful />} />,
            <Route path="success/:id" element={<Successful />} />,
            <Route path="succes/:id" element={<SuccessfulCharity />} />,
            <Route path="sucess/:id" element={<SuccessfulAdhoc />} />,
            <Route path="invoice" element={<Invoice />} />,
            <Route path="settings" element={<Settings />} />,
            <Route path="reports" element={<Reports />} />,
            <Route path="home" element={<Home />} />,
            <Route path="transaction" element={<Transaction />} />,
            <Route path={ROUTES.TOKENIZATION} element={<Tokenization />} />,
            <Route
              path="transaction-by-id/:id"
              element={<TransactionById />}
            />,
            <Route path="payment-link" element={<PaymentLinkTable />} />,
            <Route path="preview-new-payment" element={<PreviewOfPayment />} />,
            <Route
              path="preview-charity-payment"
              element={<CharityPreviewOfPayment />}
            />,
            <Route path="add-product" element={<CreatePaymentLink />} />,
            <Route path="add-users" element={<AddUser />} />,
            <Route path="products" element={<ProductList />} />,
            <Route path="user-management" element={<UserManagementHeader />} />,
            <Route path="user-profile" element={<UserProfile />} />,
            <Route path="permission" element={<Permission />} />,
            <Route path="account-settings" element={<AccountSettings />} />,
            <Route
              path="complete-account-set-up/*"
              element={<CompleteAccountSetupPage />}
              children={dynamicRoutes?.map((route) => (
                <Route path={route?.path} element={route?.element} />
              ))}
            />,
            <Route path="accounts" element={<AccountBankingService />} />,
          ]}
        />
        <Route
          path="dashboard/accounts"
          element={
            <AuthWrapper>
              <AccountTransfer>
                <Outlet />
              </AccountTransfer>
            </AuthWrapper>
          }
          children={[
            <Route path="payment-details" element={<EmptyPage />} />,
            <Route path="schedule-transfer" element={<EmptyPage />} />,
            <Route path="summary" element={<EmptyPage />} />,
            <Route path="confirmation" element={<EmptyPage />} />,
            <Route path="recipient-details" element={<EmptyPage />} />,
            <Route path="business-details" element={<EmptyPage />} />,
            <Route
              path="recipient-details-wire-transfer"
              element={<EmptyPage />}
            />,
            <Route
              path="payment-details-wire-transfer"
              element={<EmptyPage />}
            />,
            <Route
              path="recipient-details-pay-anyone"
              element={<EmptyPage />}
            />,
          ]}
        />

        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="terms-and-condition" element={<TermsCondition />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route
          path="reset-password-org-user"
          element={<ResetPasswordOrgUserPage />}
        />

        <Route
          path="iframe/bank-account-connection"
          element={<BankAccountConnectionPage />}
        />

        <Route path="/docs" element={<DocumentationApp />} />
        <Route path="*" element={<Login />} />
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
